import styled from 'styled-components';
import { MdHome, MdEvent, MdSupervisorAccount, MdArrowDropDown } from 'react-icons/md';

export const Container = styled.div`
    display:flex;
    flex-direction: column;
    position:relative;
    height: 100%;
`;

export const ContainerHeader = styled.div`
    display:flex;
    flex-direction: row;
    background-color: var(--cardBackgroundColor);
    height: 60px;
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.75);
    padding: 10px 15px;
    justify-content: space-between;
`;

export const ContainerBody = styled.div`
    height: calc(100% - 60px);
`;

export const ContainerIconSoftware = styled.div`
    display:flex;
    align-items:center;
    width:200px;
`;

export const ContainerItensMenu = styled.div`
    display:flex;
    align-items:center;
    justify-content: space-evenly;
    width:300px;
`;

const activeClassName = "active";

export const ContainerItem = styled.div`
    display:flex;
    align-items:center;
    cursor: pointer;
    color: ${ props => props.ativo ? 'var(--primaryColorHover)' : 'var(--textBlack)' } ;
    padding: 5px;
    border-radius: 5px;
    transition: all .3s ease-in-out;

    :hover{
        background-color: var(--backgroundColorHover);
        transform: translateY(-2px);
    }
`;

export const IconMdHome = styled( MdHome )`
    font-size: 30px;
`;

export const IconMdEvent = styled( MdEvent )`
    font-size: 30px;
`;

export const IconMdSupervisorAccount = styled( MdSupervisorAccount )`
    font-size: 30px;
`;

export const ContainerBtnPerfilConfig = styled.div`
    display:flex;
    align-items:center;
    padding-left: 8px;
    border-radius: 5px;
    position: relative;
    color: ${ props => props.subMenuUserIsOpen ? 'var(--primaryColorHover)' : 'var(--textBlack)' };
    ${ props => props.subMenuUserIsOpen ? 'background: var(--backgroundColorHover);' : '' };


    :hover{
        transition-duration: .3s;
        background: var(--backgroundColorHover);
        cursor: pointer;
    }

    > span {
        font-weight: 600;
        font-size: 16px;
    }


`;

export const SubMenu = styled.div`
    display: ${ props => props.subMenuUserIsOpen ? 'flex' : 'none' };
    position: absolute;
    color: var(--textBlack);
    top: 45px;
    right: 1px;
    /* height: 200px; */
    width: 200px;
    background: var(--cardBackgroundColor);
    box-shadow: 0px 0px 10px -4px rgba(0,0,0,0.75);
    border-radius: 5px;
    flex-direction: column;
    justify-content: flex-start;
    align-content: center;
    padding: 5px;

    > ul {
        list-style: none;

        > li {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            padding: 10px 15px;
            border-radius: 5px;

            >span {
                font-size: 16px;
                font-weight: 500;
            }

            >svg {
                font-size: 30px;
                margin-right: 5px;
                padding: 5px;
                background:  var(--backgroundColorHover);
                border-radius: 50%;
            }

            :hover{
                background:  var(--backgroundColorHover);
            }
        }
    }

`;

export const IconMdArrowDropDown = styled( MdArrowDropDown )`
    font-size: 35px;
    padding: 3px;
    border-radius: 50%;
    background:  var(--backgroundColorHover);
    margin-left: 5px;

    /* :hover{
        transition-duration: .3s;
        background: #cecece;
    } */
`;

export const ContainerBtnsHeadSide = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 600;
    background: var(--backgroundColorHover);
    border-radius: 50%;
    width: 35px;
    height: 35px;
    cursor: pointer;

    margin-left: 5px;
    :hover{
        transition-duration: .3s;
        background: #cecece;
    }
`;

export const ContainerPopUpUsuarios = styled.div`
    position:absolute;
    top:1px;
    right:1px;
    width: 100px;
    height: 100px;
    background: red;
`;

export const ContainerIconesSociais = styled.div`
    margin: 0px 5px;
    cursor: pointer;

    :hover{
        svg{
            color: var(--primaryColorHover);
        }

    }

    svg {
        font-size: 35px;
    }

`;

export const ContainerTermo = styled.div`
    display: flex;
    height: 100%;
    width:100%;
    flex-direction: column;
    padding: 15px;
    flex: auto 0 1;

    
`;

